module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-it-IT.9bb67f1d.jpg";